import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  baseBoxShadowFocus,
  borderRadius8,
  standardInsetBoxShadow,
} from '../borders.style';
import {
  grey1,
  grey2,
  grey3,
  grey5,
  grey6,
  grey9,
  purple1,
  purple7,
  purple9,
} from '../colours.style';
import { spacing4, spacing8, spacing12 } from '../spacing.style';
import { fontSize16, fontWeightNormal } from '../typography.style';
import { flexCentreAlignCss } from '../flex.style';

type CheckableGroupProps = {
  $canWrap?: boolean;
  'data-selector'?: string;
};
export const CheckableGroup = styled.div.attrs<CheckableGroupProps>({
  'data-selector': 'checkable-group',
})`
  display: flex;
  gap: ${rem(spacing8)};
  ${({ $canWrap = true }) =>
    $canWrap &&
    `
    flex-wrap: wrap;
  `}
`;

type BaseProps = {
  $isSmall?: boolean;
  $isRound?: boolean;
  $isPill?: boolean;
  $isDisabled?: boolean;
  $marginBottom?: number;
};

export const CheckableContainer = styled.div<BaseProps>`
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
  position: relative;

  &:last-child {
    margin-right: 0;
  }
  label {
    ${flexCentreAlignCss}
    display: inline-flex;
    background-color: ${grey1};
    border: 1px solid ${grey5};
    border-radius: ${rem(borderRadius8)};
    color: ${grey9};
    font-size: ${rem(fontSize16)};
    font-weight: ${fontWeightNormal};
    height: ${({ $isSmall }) => rem($isSmall ? 32 : 40)};
    min-width: ${({ $isSmall }) => rem($isSmall ? 32 : 40)};
    max-width: 100%;
    margin: 0;
    padding: 0 ${rem(spacing4)};
    position: relative;

    &:hover {
      background-color: ${grey2};
      border-color: ${grey9};
      cursor: pointer;
    }

    ${({ $isPill }) =>
      $isPill &&
      `
      border-radius: ${rem(40)};
      padding: 0 ${rem(spacing12)};
    `}

    ${({ $isRound }) =>
      $isRound &&
      `
      border-radius: ${rem(40)};
      padding: 0;
    `}

    ${({ $isDisabled }) =>
      $isDisabled &&
      `
      background-color: ${grey3};
      border-color: ${grey5};
      color: ${grey6};
      cursor: not-allowed;
      box-shadow: none !important;
      &:hover {
        background-color: ${grey3};
        border-color: ${grey5};
        cursor: not-allowed;
      }
    `}
  }

  input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 0;
    padding: 0;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
  }

  input:focus + label {
    border-color: ${grey1};
    box-shadow: ${baseBoxShadowFocus};
    outline: 0;
  }

  input:checked + label {
    color: ${purple9};
    background-color: ${purple1};
    border-color: ${purple7};
  }

  input:active + label {
    ${standardInsetBoxShadow}
  }
`;
